<template>
      <div class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-between">
          <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
              <h3 class="card-title card-title m-0 ">{{title}}</h3>
          </div>
          <div class="col-xs-12 col-sm-auto p-t-5 p-b-5" v-if="buttons!=undefined">
              <button class="btn btn-icon waves-effect waves-light p-r-20 m-l-5" :class="btn.class==undefined?'btn-info':btn.class" type="button" v-for="btn,index in buttons" @click="$emit(btn.emit)" :key="index">
                  <span class="btn-label m-0 p-0"><i :class="btn.icon"></i></span>
                  <span class="p-l-20 p-r-10">{{btn.title}}</span>
              </button>
          </div>
      </div>
</template>

<script>
    export default {
        name:"cardHead",
        props:{
            title:String,
            buttons:Array
        }
    }
</script>

<style>

</style>